import PropTypes from 'prop-types';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Box } from 'foundations-components/transitional/components/Box';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'ui-a... Remove this comment to see the full error message
import KnowledgeBaseButton from 'ui-addon-i18n/components/KnowledgeBaseButton';
import LearnMoreModalListItem from '../base/LearnMoreModalListItem';
import LearnMoreModal from '../base/LearnMoreModal';
import { useModalTracker } from '../../../hooks/tracking';
import { KNOWLEDGE_BASE_CREATE_BOT_URL } from '../../../utils/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const CreateBotModal = ({
  onClose
}) => {
  const {
    trackLink
  } = useModalTracker('CreateBotModal');
  return /*#__PURE__*/_jsxs(LearnMoreModal, {
    footer: /*#__PURE__*/_jsx(KnowledgeBaseButton, {
      onClick: () => trackLink('click create bot article'),
      url: KNOWLEDGE_BASE_CREATE_BOT_URL,
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.readInstructions"
      })
    }),
    heading: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.modal.createBot.heading"
    }),
    illustrationName: "robot",
    onClose: onClose,
    children: [/*#__PURE__*/_jsx(Box, {
      marginBlockEnd: "500",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "setup-guide-components.modal.createBot.description"
      })
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: "setup-guide-components.modal.createBot.li1"
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: "setup-guide-components.modal.createBot.li2"
    }), /*#__PURE__*/_jsx(LearnMoreModalListItem, {
      message: "setup-guide-components.modal.createBot.li3"
    }), /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.modal.createBot.p1"
    })]
  });
};
CreateBotModal.propTypes = {
  onClose: PropTypes.func
};
export default CreateBotModal;